module.exports = __webpack_public_path__ + "iPadGuide2@2x.ee924883.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/iPadGuide2@2x.png
// module id = WoqI
// module chunks = 0